import { Md5 } from 'ts-md5';

import { sendVerificationCode as sendCode } from '@api/user.api'
import { User } from "@store/types";
import { ActionType } from '@store/action-type.constant.t';
import store from '@store/index';


export function setLocalUser(user: User) {
  window.localStorage.setItem('user', JSON.stringify(user));
}
export function removeLocalUser() {
  window.localStorage.removeItem('user');
}
export async function sendVerificationCode(phoneNo: string) {
  const t = Date.now().toString();
  const sign = genLoginSign(phoneNo, t);
  const res = await sendCode({
    telephone: phoneNo,
    sign,
    t,
  })
  return res.data;
}

function genLoginSign(phoneNo: string, t: string) {
  const md5 = new Md5();
  const ENC_KEY = 'RuGuoZaiGongJiJiuBaoJingLe';
  md5.appendStr(phoneNo).appendStr(t).appendStr(ENC_KEY);
  const sign = md5.end().toString();
  return sign;

}

export function setAccessToken(token: string) {
  window.accessToken = token;
  let localUser = JSON.parse(window.localStorage.user);
  localUser.accessToken = token;
  window.localStorage.setItem('user', JSON.stringify(localUser));
}

export function getRefreshToken(): string {
  const localUser = JSON.parse(window.localStorage.user);
  return localUser.refreshToken;
}

export function logOut() {
  store.dispatch({
    type: ActionType.REMOVE_USER,
  });
  removeLocalUser();
  window.accessToken = '';
}